import { CalculatorType, Scenario } from 'spw-redux/modules/calculators/types';
import { IBuilding } from 'spw-redux/modules/projects/types';
import { GROWTH_CALCULATORS } from 'spw-constants';
import ProgramScenario, { PlainProgramScenario } from './Scenario';
import ProgramScenarioFactory from './ProgramScenarioFactory';
import USFScenario from './USFScenario';

const getFloor = (floorId: number, building: IBuilding) =>
  building?.floors?.find((floor) => floor.id === floorId);

export default class FloorUSFScenario extends USFScenario {
  constructor(apiScenario: Scenario) {
    const floor = getFloor(apiScenario.floorId, apiScenario.building);
    super(apiScenario, floor?.totalFloorUsf || 0);
    if (floor) {
      this.primaryLabel = floor.name;
    }
    this.calculationsLabel = 'Floor';
    this.calculationsTitlePrefix = 'Floor';
  }

  static parseFromAnotherCalculatorType(
    scenario: PlainProgramScenario,
    floorId: number
  ) {
    const newScenario = USFScenario.parseToUSFScenario(
      scenario,
      GROWTH_CALCULATORS.floorUsf as CalculatorType
    );
    newScenario.floorId = floorId;

    return ProgramScenarioFactory.create(
      ProgramScenario.toAPIScenario(newScenario)
    );
  }
}
